import { PrintView } from '../Print/types';
import { GroupCol, GroupRow } from '../types';

export function getView({
  groupCol,
  groupRow,
}: {
  groupCol: GroupCol;
  groupRow: GroupRow;
}): PrintView {
  // classic
  if (groupCol === 'domaines' && groupRow === 'periodes') {
    return 'domaine_x_periode';
  }
  if (groupCol === 'domaines' && groupRow === 'semaines') {
    return 'domaine_x_periode';
  }
  if (groupCol === 'periodes' && groupRow === 'domaines') {
    return 'periode_x_domaine';
  }
  if (groupCol === 'semaines' && groupRow === 'domaines') {
    return 'periode_x_domaine';
  }

  // unified
  if (groupCol === 'periodes' && groupRow === 'matieres') {
    return 'periode_x_matiere';
  }
  if (groupCol === 'semaines' && groupRow === 'matieres') {
    return 'periode_x_matiere';
  }
  if (groupCol === 'matieres' && groupRow === 'periodes') {
    return 'matiere_x_periode';
  }
  if (groupCol === 'matieres' && groupRow === 'semaines') {
    return 'matiere_x_periode';
  }

  // condensed
  if (groupCol === 'periodes' && groupRow === 'semaines') {
    return 'periode_x_semaine';
  }

  // default
  return 'domaine_x_periode';
}
